const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_pages/$lang/_legal/privacy/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { alternatesToLinks, buildLocalizedPageAlternates } from "@/i18n/alternates";
import { buildPagePreviewMetaTags } from "@/lib/buildPagePreviewMetaTags";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_pages/$lang/_legal/privacy/")({
  head: async ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const t = createTranslator({
      locale,
      messages,
      namespace: "globals.legal"
    });
    const alts = buildLocalizedPageAlternates(locale, "privacy");
    return {
      meta: await buildPagePreviewMetaTags({
        title: t("privacyTitle"),
        description: t("privacyDescription"),
        canonicalUrl: alts.canonical
      }, {}, {
        locale
      }),
      links: alternatesToLinks(alts)
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});